<!-- header for a new channel -->
<div class="page-heading-blue" *ngIf="isNew">
  <h1>{{'PROGRAMS' | translate}}&nbsp;<i class="fal fa-angle-right"></i>
    {{ (isNewTemplate ? 'NEW-PROGRAM-TEMPLATE' : 'CREATE-NEW-PROGRAM') | translate}}
  </h1>
  <span *ngIf="isTemplate.value" style="float:right;margin-right:30px;top:-62px;"
    class="badge badge-pill channel-status text-uppercase channel-status-template">{{getChannelStatusKey('Template') |
    translate}}
  </span>
</div>

<!-- header for an existing program -->
<div class="page-heading-blue pt-3 pb-3 pl-2" *ngIf="!isNew">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-3 col-xl-4">
        <div class="headerText">
          {{'PROGRAMS' | translate }}&nbsp;<i class="fal fa-angle-right fa-lg"></i>
        </div>
        <div class="headerText" *ngIf="!loading">
          <h2>{{program?.name}}</h2>
        </div>
      </div>
      <div *ngIf="!loading" class="col-sm-6 col-md-4 col-lg-3 col-xl-3 my-auto text-nowrap header-timestamp">
        <label class="text-right headerText">{{'LAST-MODIFIED-BY' | translate}}:</label>
        <span class="ml-2">{{program.lastModifiedBy}}</span>
        <br />
        <label class="text-right headerText">{{'LAST-MODIFIED-DATE' | translate}}:</label>
        <span class="ml-2">{{program.lastModifiedOn | date:'medium'}}</span>
      </div>
      <div *ngIf="!loading" class="col-sm-6 col-md-4 col-lg-3 col-xl-3 my-auto text-nowrap header-timestamp">
        <label class="text-right headerText">{{'CREATED-BY' | translate}}:</label>
        <span class="ml-2">{{program.createdBy}}</span>
        <br />
        <label class="text-right headerText">{{'CREATED-DATE' | translate}}:</label>
        <span class="ml-2">{{program.createdOn | date:'medium'}}</span>
      </div>
      <div *ngIf="!loading"
        class="col-sm-2 col-md-4 col-lg-2 col-xl-2 my-auto align-right text-nowrap header-timestamp">
        <span *ngIf="isTemplate.value" style="float:right;margin-right:15px;top:-10px;"
          class="ml-2 badge badge-pill channel-status text-uppercase channel-status-template">{{getChannelStatusKey('Template')
          | translate}}
        </span>
        <br />
        <label class="text-right headerText">{{'VERSION' | translate}}:</label>
        <span class="ml-2">{{program.version}}</span>
      </div>
    </div>
  </div>
</div>

<!--Loading div-->
<div *ngIf="loading" class="page-wrap d-flex flex-row align-items-center mt-5">
  <div class="container">
    <div class="row justify-content-center">
      <span class="k-icon k-i-loading kendo-loading-icon"></span>
    </div>
  </div>
</div>

<kendo-tabstrip *ngIf="!loading">
  <kendo-tabstrip-tab title="{{ 'SUMMARY' | translate }}" [selected]="true">
    <ng-template kendoTabContent>
      <form [formGroup]="programForm" class="k-form mt-4 mb-4">
        <!--Templates-->
        <div class="row mb-3" *ngIf="isNew && programTemplates.length > 0 && !isNewTemplate">
          <div class="col-sm-6">
            <div>
              <label class="k-form-field mb-0 mt-0">
                <span class="k-text-uppercase dark emphasizedLabel">
                  {{'CREATE-FROM-PROGRAM-TEMPLATE' | translate}}
                </span>
              </label>
            </div>
            <div>
              <kendo-combobox id="programTemplatesDropdown" [data]="programTemplatesFiltered" [valueField]="'id'"
                formControlName="template" [textField]="'name'" [filterable]="true"
                (filterChange)="filterProgramTemplates($event)" class="w-50">
              </kendo-combobox>
            </div>
          </div>
        </div>
        <div class="secondary-card">
          <div class="secondary-card-header">
            <h5 class="collapsible-text" (click)="programEditDetailsCollapsible.toggleChange()">
              {{'PROGRAM-DETAILS-SECTION-HEADER' | translate}}
              <app-collapsible #programEditDetailsCollapsible [storageKey]="'program-edit-details'"
                (collapsibleToggle)="programDetailsCollapsed=$event">
              </app-collapsible>
            </h5>
          </div>
          <div class="card-body" *ngIf="!programDetailsCollapsed">
            <div class="row">
              <div class="col-sm-6">
                <div>
                  <!-- Channel name and description -->
                  <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                      {{'PROGRAM-NAME' | translate}} *
                    </span>
                    <input id="name" kendoTextBox formControlName="name" maxlength="255" />
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                      *ngIf="name.touched && name.errors?.required">
                      {{'REQUIRED-NAME' | translate}}
                    </div>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                      *ngIf="name.touched && name.errors?.maxlength">
                      {{'NAME-LONGER-THAN-255' | translate}}
                    </div>
                  </label>
                </div>
                <!-- Program Category -->
                <div>
                  <label class="k-form-field mb-0">
                    <span class="k-text-uppercase dark">
                      {{'PROGRAM-EDIT-CATEGORY' | translate}} *
                    </span>
                  </label>
                  <kendo-combobox id="programCategoryDropdown" [data]="programCategoriesFiltered" [valueField]="'id'"
                    [textField]="'name'" formControlName="category" [filterable]="true" class="w-50"
                    [itemDisabled]="itemDisabled" (filterChange)="filterProgramCategories($event)">
                  </kendo-combobox>
                  <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="formFieldInvalid('category')">
                    {{'REQUIRED-PROGRAM-CATEGORY' | translate}}
                  </div>
                </div>
                <!-- Primary Program Lead -->
                <div>
                  <label class="k-form-field mb-0">
                    <span class="k-text-uppercase dark">
                      {{'PROGRAM-EDIT-LEAD' | translate}} * <span style="display: inline-flex">
                        <div #tipA kendoTooltip position="right" class="keyboard-accessible" tabindex="0" showOn="none"
                          (focus)="showTooltip(programLeadTooltip,tipA)"
                          (mouseover)="showTooltip(programLeadTooltip,tipA)" (blur)="hideTooltip(tipA)"
                          (mouseout)="hideTooltip(tipA)" aria-live="polite">
                          <a #programLeadTooltip title="{{'PRIMARY-PROGRAM-LEAD-INFO' | translate }}"><i
                              class="fa fa-info-circle pointer"></i></a>
                        </div>
                      </span>
                    </span>
                  </label>
                  <kendo-combobox id="programLeadDropdown" [data]="programLeadsFiltered" [valueField]="'id'"
                    [textField]="'name'" formControlName="leader" [filterable]="true" (close)="searchTerm=''"
                    (filterChange)="filterProgramLeads($event)" [itemDisabled]="programLeadItemDisabled"
                    (valueChange)="updateOrganization($event)" class="w-50">
                    <ng-template kendoComboBoxItemTemplate let-dataItem>
                      <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                      </span>
                    </ng-template>
                  </kendo-combobox>
                  <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="formFieldInvalid('leader')">
                    {{'REQUIRED-PROGRAM-LEAD' | translate}}
                  </div>
                </div>
                <!-- Secondary Program Leads -->
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'PROGRAM-EDIT-SECONDARY-LEADS' | translate}} <span style="display: inline-flex">
                      <div #tipB kendoTooltip position="right" class="keyboard-accessible" tabindex="0" showOn="none"
                        (focus)="showTooltip(secondaryLeadsTooltip,tipB)" aria-live="polite"
                        (mouseover)="showTooltip(secondaryLeadsTooltip,tipB)" (blur)="hideTooltip(tipB)"
                        (mouseout)="hideTooltip(tipB)">
                        <a #secondaryLeadsTooltip title="{{'SECONDARY-PROGRAM-LEADS-INFO' | translate }}"><i
                            class="fa fa-info-circle pointer"></i></a>
                      </div>
                    </span>
                  </span>
                  <kendo-multiselect [data]="programGroupsFiltered" formControlName="groups" [textField]="'name'"
                    [filterable]="true" [valueField]="'id'" [autoClose]="true" [itemDisabled]="itemDisabled">
                    <ng-template kendoMultiSelectItemTemplate let-dataItem>
                      <div class="m-1">
                        <input type="checkbox" [checked]="isGroupSelected('groups', dataItem.id)" kendoCheckBox />
                        <label class="k-checkbox-label">{{ dataItem.name }}</label>
                      </div>
                    </ng-template>
                  </kendo-multiselect>
                </label>
              </div>
              <div class=" col-sm-6">
                <!--Program Description-->
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'PROGRAM-DESCRIPTION' | translate}} *
                  </span>
                  <textarea kendoTextArea rows="4" formControlName="description" maxlength="1024"
                    class="w-100"></textarea>
                  <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="formFieldInvalid('description')">
                    {{'REQUIRED-DESCRIPTION' | translate}}
                  </div>
                </label>
                <label class="k-form-field" style="margin-top: 22px;">
                  <span class="k-text-uppercase dark">
                    {{'PROGRAM-EDIT-ORGANIZATION' | translate}}
                  </span>
                  <kendo-combobox id="programOrganizationDropdown" [data]="organizationsFiltered" [valueField]="'id'"
                    [textField]="'name'" formControlName="organization" [filterable]="true"
                    [itemDisabled]="itemDisabled" [readonly]="isCommunityCoordinatorRole"
                    (filterChange)="filterOrganizations($event)" class="w-50">
                  </kendo-combobox>
                </label>
              </div>
            </div>
          </div>
        </div>
        <!-- Channels -->
        <div class="secondary-card mt-4">
          <div class="secondary-card-header">
            <h5 class="collapsible-text" (click)="programEditChannelsCollapsible.toggleChange()">{{'CHANNELS' |
              translate}}
              <app-collapsible #programEditChannelsCollapsible [storageKey]="'program-edit-channels'"
                (collapsibleToggle)="channelDetailsCollapsed=$event">
              </app-collapsible>
            </h5>
          </div>
          <div class="card-body p-2" *ngIf="!channelDetailsCollapsed" [ngClass]="{'pb-5': channelDisabled}">
            <div class="container-fluid">
              <div class="font-weight-bold mt-2">
                {{'CHANNEL-CONFIGURATION' | translate}}
              </div>
              <div class="pb-3 channel-description">
                {{'CHANNEL-CONFIGURATION-DESCRIPTION' | translate}}
              </div>
              <!--Channels-->
              <div class="pb-4 border-bottom" formArrayName="channels"
                *ngFor="let item of programForm.get('channels').controls; let i = index;"
                [ngClass]="{'mt-4': i > 0, 'mb-4': i === programForm.get('channels').controls.length-1}">
                <div class="row">
                  <!-- Channel -->
                  <div class="col-10" [formGroupName]="i">
                    <div class="row">
                      <div class="col-5">
                        <input kendoTextBox (keydown)="validateKey($event)" formControlName="name" maxlength="255"
                          class="w-100 k-textbox" />
                      </div>
                      <div class="col-7">
                        <div class="row">
                          <div class="col-4 mt-2 p-0" style="max-width:140px;">
                            <!--Edit Channel - Enabled and Disabled-->
                            <i *ngIf="programForm.controls.channels.controls[i].controls.id.value && 
                                      programForm.controls?.channels.controls[i].controls.status.value !== 'Deleted' &&
                                      programForm.controls.channels.controls[i].controls.canAccess.value"
                              class="fas fa-lg fa-edit button-container-width" title="{{'EDIT-CHANNEL' | translate}}"
                              (click)="onEditChannel(programForm.controls.channels.controls[i].controls.id.value)">
                            </i>
                            <i *ngIf="!(programForm.controls.channels.controls[i].controls.id.value && 
                                      programForm.controls?.channels.controls[i].controls.status.value !== 'Deleted') &&
                                      programForm.controls.channels.controls[i].controls.canAccess.value"
                              class="fas fa-lg fa-edit button-container-width icon-disabled"
                              title="{{'EDIT-CHANNEL' | translate}}">
                            </i>
                            <!--Delete Channel - Enabled and Disabled-->
                            <i class="fas fa-trash-alt fa-lg button-container-width" title="{{ 'DELETE' | translate }}"
                              *ngIf="!disableFormControl() &&
                                      programForm.controls?.channels.controls[i].controls.status.value !== 'Deleted' &&
                                      programForm.controls?.channels.controls[i].controls.status.value !== 'Online'  && !channelDisabled &&
                                      programForm.controls.channels.controls[i].controls.canAccess.value"
                              (click)="removeChannel(i,programForm.controls.channels.controls[i].controls.id.value)">
                            </i>
                            <i class="fas fa-trash-alt fa-lg button-container-width icon-disabled"
                              title="{{ 'DELETE' | translate }}"
                              *ngIf="!(!disableFormControl() && programForm.controls?.channels.controls[i].controls.status.value !== 'Deleted' &&
                                                              programForm.controls?.channels.controls[i].controls.status.value !== 'Online') &&
                                                              programForm.controls.channels.controls[i].controls.canAccess.value && !channelDisabled">
                            </i>
                            <!--Export Channel - Enabled and Disabled-->
                            <i *ngIf="programForm.controls?.channels.controls[i].controls.appId.value !== null && 
                                    programForm.controls?.channels.controls[i].controls.status.value !== 'Deleted' && !channelDisabled &&
                                    programForm.controls.channels.controls[i].controls.canAccess.value"
                              class="fas fa-download button-container-width" title="{{'EXPORT-CHANNEL' | translate}}"
                              (click)="exportModel(i)">
                            </i>
                            <i *ngIf="!(programForm.controls?.channels.controls[i].controls.appId.value !== null && 
                                      programForm.controls?.channels.controls[i].controls.status.value !== 'Deleted') && !channelDisabled &&
                                      programForm.controls.channels.controls[i].controls.canAccess.value &&
                                      programForm.controls.channels.controls[i].controls.status.value !== 'Template'"
                              class="fas fa-download button-container-width icon-disabled"
                              title="{{'EXPORT-CHANNEL' | translate}}">
                            </i>
                            <!--Import Channel - Enabled and Disabled-->
                            <i *ngIf="programForm.controls?.channels.controls[i].controls.appId.value === null && 
                                    programForm.controls?.channels.controls[i].controls.status.value !== 'Deleted' && !channelDisabled &&
                                    programForm.controls.channels.controls[i].controls.canAccess.value"
                              class="fas fa-upload pointer button-container-width"
                              title="{{'IMPORT-CHANNEL' | translate}}" (click)="importIndex=i;fileInput.click()">
                            </i>
                            <input class="d-none" type="file" accept=".zip, application/zip"
                              (change)="onFileChanged($event)" #fileInput />
                          </div>
                          <div class="col-8">
                            <!--Template Channel only if no model import is selected-->
                            <div class="row"
                              *ngIf="!programForm.controls.channels.controls[i].controls.id.value && !channelDisabled &&
                                      programForm.controls.channels.controls[i].controls.canAccess.value &&
                                      programForm.controls?.channels.controls[i].controls.modelFileName.value === null">
                              <div class="col-3 text-right p-0 pt-2">
                                <span class="k-text-uppercase dark">{{'TEMPLATE' | translate}}</span>
                              </div>
                              <div class="col-9">
                                <kendo-combobox class="w-100" formControlName="templateChannel" [valuePrimitive]="false"
                                  [data]="templateGroupedChannels" [textField]="'name'" [valueField]="'id'"
                                  (valueChange)="templateChannelChange($event, i)">
                                </kendo-combobox>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="programForm.controls?.channels.controls[i].controls.modelFileName.value !== null">
                      <label>
                        <span class="k-text-uppercase dark">{{'SELECTED-IMPORT-MODEL' | translate}}</span>
                        <i class="fas fa-long-arrow-alt-right ml-2 mr-2 import-arrow"></i>
                        {{programForm.controls?.channels.controls[i].controls.modelFileName.value}}
                        <!--Delete Channel Model selected model-->
                        <i class="fas fa-times-circle fa-delete-custom" title="{{'DELETE-CHANNEL' | translate}}"
                          (click)="deleteChannelZip(i)" style="position: relative;top: 3px;">
                        </i>
                      </label>
                    </div>
                    <div class="k-tooltip k-tooltip-validation" role="alert" [hidden]="programForm.controls.channels.controls[i].controls.name.valid || 
                                programForm.controls.channels.controls[i].controls.name.pristine">
                      {{ 'REQUIRED-NAME' | translate }}
                    </div>
                  </div>
                  <div class="col-1">
                    <span class="badge badge-pill channel-status text-uppercase" style="margin-top:13px"
                      [ngClass]="{'channel-status-offline': programForm.controls?.channels.controls[i].controls.status.value === 'Offline',
                                  'channel-status-simulated': programForm.controls?.channels.controls[i].controls.status.value === 'Simulated', 
                                  'channel-status-online': programForm.controls?.channels.controls[i].controls.status.value === 'Online',
                                  'channel-status-deleted': programForm.controls?.channels.controls[i].controls.status.value === 'Deleted',
                                  'channel-status-template': programForm.controls?.channels.controls[i].controls.status.value === 'Template',
                                  'channel-status-archived': programForm.controls?.channels.controls[i].controls.status.value === 'Archived'}">
                      {{getChannelStatusKey(programForm.controls?.channels.controls[i].controls.status.value) |
                      translate}}
                    </span>
                  </div>
                  <div class="col-1" style="text-align: end;" *ngIf="changeChannelOrderSwitch"
                    [ngClass]="{'change-order-button-adjustments ': (i > 0 && programForm.get('channels').controls.length-1 > i)}">
                    <div>
                      <i title="{{'MOVE-UP'|translate}}" *ngIf="i > 0"
                        class="fa fa-arrow-circle-up pointer fa-delete-custom" (click)="changeChannelOrder(i,'up')">
                      </i>
                    </div>
                    <div>
                      <i title="{{'MOVE-DOWN'|translate}}" *ngIf="programForm.get('channels').controls.length-1 > i"
                        class="fa fa-arrow-circle-down pointer fa-delete-custom" (click)="changeChannelOrder(i,'down')">
                      </i>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Add a new channel -->
              <div class="mb-3">
                <button *ngIf="!channelDisabled" kendoButton [primary]="false" type="button" (click)="onAddChannel()"
                  [disabled]="disableFormControl()">
                  {{'ADD-CHANNEL' | translate}}<i class="far fa-plus"></i>
                </button>
                <app-advanced-mode id="changeChannelOrderSwitch" [storageKey]="'change-channel-order'"
                  style="float: right;" [titleKey]="'SET-ORDER'" (collapsibleToggle)="changeChannelOrderSwitch=$event"
                  *ngIf="programForm.get('channels').controls.length > 1">
                </app-advanced-mode>
              </div>
            </div>
          </div>
        </div>
        <!-- Program Outcome Metrics -->
        <div class="secondary-card mt-4">
          <div class="secondary-card-header">
            <h5 class="collapsible-text" (click)="programMetricsCollapsible.toggleChange()">{{'PROGRAM-OUTCOME-METRICS'
              |
              translate}}
              <app-collapsible #programMetricsCollapsible [storageKey]="'program-edit-metrics'"
                (collapsibleToggle)="programMetricsCollapsed=$event">
              </app-collapsible>
            </h5>
          </div>
          <div class="card-body p-2" *ngIf="!programMetricsCollapsed">
            <div class="container-fluid">
              <div class="font-weight-bold mt-2">
                {{'PROGRAM-METRIC-CONFIGURATION' | translate}}
              </div>
              <div class="pb-3 channel-description">
                {{'PROGRAM-METRIC-CONFIGURATION-DESCRIPTION' | translate}}
              </div>
              <!--Metrics-->
              <div class="pb-4 border-bottom" formArrayName="metrics"
                *ngFor="let item of programForm.get('metrics').controls; let i = index;"
                [ngClass]="{'mt-4': i > 0, 'mb-4': i === programForm.get('metrics').controls.length-1}">
                <div class="row">
                  <!-- Metric -->
                  <div class="col-12" [formGroupName]="i">
                    <div class="row">
                      <div class="col-3">
                        <!--Metric-->
                        <div class="row">
                          <div class="col-3">
                            <label class="pt-2">
                              <span class="k-text-uppercase dark">
                                {{'PROGRAM-METRIC' | translate}}
                              </span>
                            </label>
                          </div>
                          <div class="col-9">
                            <kendo-combobox formControlName="metric" class="w-100" [valuePrimitive]="false"
                              [itemDisabled]="itemDisabled" [data]="allMetrics" [textField]="'name'"
                              [valueField]="'id'">
                            </kendo-combobox>
                            <div class="k-tooltip k-tooltip-validation" role="alert" [hidden]="programForm.controls.metrics.controls[i].controls.metric.valid || 
                                        !programForm.controls.metrics.controls[i].controls.metric.touched">
                              {{ 'REQUIRED-METRIC' | translate }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-2">
                        <!--Target for Rate Based selection-->
                        <div class="row"
                          *ngIf="programForm.controls.metrics.controls[i].controls.metric && 
                                 programForm.controls.metrics.controls[i].controls.metric.value && 
                                 programForm.controls.metrics.controls[i].controls.metric.value.metricType === 'RATE_BASED'">
                          <div class="col-4">
                            <label class="pt-2">
                              <span class="k-text-uppercase dark">
                                {{'TARGET' | translate}}
                              </span>
                            </label>
                          </div>
                          <div class="col-8">
                            <kendo-numerictextbox [format]="'n0'" formControlName="target" [min]="0" [max]="100">
                            </kendo-numerictextbox>
                            <div class="k-tooltip k-tooltip-validation" role="alert" [hidden]="programForm.controls.metrics.controls[i].controls.target.valid || 
                                        !programForm.controls.metrics.controls[i].controls.target.touched">
                              {{ 'REQUIRED-TARGET' | translate }}
                            </div>
                          </div>
                        </div>
                        <!--Rate-->
                        <div class="row mt-2"
                          *ngIf="programForm.controls.metrics.controls[i].controls.metric && 
                                 programForm.controls.metrics.controls[i].controls.metric.value && 
                                 programForm.controls.metrics.controls[i].controls.metric.value.metricType === 'RATE_BASED'">
                          <div class="col-4">
                            <label class="pt-2">
                              <span class="k-text-uppercase dark">
                                {{'RATE' | translate}}
                              </span>
                            </label>
                          </div>
                          <div class="col-8">
                            <kendo-textbox [disabled]="true" value="{{'CALCULATED' | translate}}"
                              *ngIf="programForm.controls.metrics.controls[i].controls.metric.value.metricRateMode === 'CALCULATED'">
                            </kendo-textbox>
                            <kendo-numerictextbox [format]="'n0'" formControlName="rate" [min]="0" [max]="100"
                              *ngIf="programForm.controls.metrics.controls[i].controls.metric.value.metricRateMode === 'MANUAL'">
                            </kendo-numerictextbox>
                            <div class="k-tooltip k-tooltip-validation" role="alert" [hidden]="programForm.controls.metrics.controls[i].controls.rate.valid || 
                                        !programForm.controls.metrics.controls[i].controls.rate.touched">
                              {{ 'RATE-REQUIRED' | translate }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-3">
                        <!--Numerator-->
                        <div class="row" *ngIf="programForm.controls.metrics.controls[i].controls.metric &&
                                       programForm.controls.metrics.controls[i].controls.metric.value">
                          <div class="col-8">
                            <label class="pt-2 float-right">
                              <span class="k-text-uppercase dark">
                                {{programForm.controls.metrics.controls[i].controls.metric.value.numeratorDescription}}
                              </span>
                            </label>
                          </div>
                          <div class="col-4">
                            <kendo-textbox [disabled]="true" value="{{'CALCULATED' | translate}}"
                              *ngIf="programForm.controls.metrics.controls[i].controls.metric.value.numerator !== null">
                            </kendo-textbox>
                            <kendo-numerictextbox
                              *ngIf="programForm.controls.metrics.controls[i].controls.metric.value.numerator === null"
                              [format]="'#'" formControlName="numerator" [min]="0">
                            </kendo-numerictextbox>
                          </div>
                        </div>
                      </div>
                      <div class="col-3">
                        <!--Denominator-->
                        <div class="row" *ngIf="programForm.controls.metrics.controls[i].controls.metric &&
                                       programForm.controls.metrics.controls[i].controls.metric.value">
                          <div class="col-8">
                            <label class="pt-2 float-right">
                              <span class="k-text-uppercase dark">
                                {{programForm.controls.metrics.controls[i].controls.metric.value.denominatorDescription}}
                              </span>
                            </label>
                          </div>
                          <div class="col-4">
                            <kendo-textbox [disabled]="true" value="{{'CALCULATED' | translate}}"
                              *ngIf="programForm.controls.metrics.controls[i].controls.metric.value.denominator !== null">
                            </kendo-textbox>
                            <kendo-numerictextbox
                              *ngIf="programForm.controls.metrics.controls[i].controls.metric.value.denominator === null"
                              [format]="'#'" formControlName="denominator" [min]="0">
                            </kendo-numerictextbox>
                          </div>
                        </div>
                      </div>
                      <div class="col-1 mt-2">
                        <div class="row">
                          <!--Delete Metric-->
                          <i class="fas fa-trash-alt fa-lg button-container-width" title="{{ 'DELETE' | translate }}"
                            *ngIf="!disableFormControl()" style="position:absolute;right:0"
                            (click)="removeMetric(i,programForm.controls.metrics.controls[i].controls.id.value)">
                          </i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Add a new metric -->
              <div class="mb-3">
                <button kendoButton [primary]="false" type="button" (click)="onAddMetric()"
                  [disabled]="disableFormControl()">
                  {{'ADD-METRIC' | translate}}<i class="far fa-plus"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid mt-3">
          <div class="row">
            <!-- cancel & save buttons -->
            <div class="col pt-2 pr-0">
              <div class="text-right text-nowrap">
                <button kendoButton class="mr-3" *ngIf="isNew" (click)="cancelNewProgram()">{{'CANCEL' |
                  translate}}</button>
                <button appPreventClick kendoButton [disabled]="disableSave()" (click)="onSubmit()">{{'SAVE' |
                  translate}}</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </ng-template>
  </kendo-tabstrip-tab>
  <kendo-tabstrip-tab title="{{ 'AUDIT' | translate }}">
    <ng-template kendoTabContent>
      <div class="content-background pt-0">
        <app-program-audit-list [programId]="program.id"></app-program-audit-list>
      </div>
    </ng-template>
  </kendo-tabstrip-tab>
</kendo-tabstrip>